import React from 'react';
import { Pagination } from 'react-bootstrap';

interface Props {
    currentPage: number;
    setCurrentPage: React.Dispatch<number>;
    totalPage: number;
}

const RenderPagination: React.FC<Props> = (props) => {
  const { setCurrentPage, totalPage, currentPage } = props;

  return (
    <Pagination>
      <Pagination.First
        onClick={() => setCurrentPage(1)}
        disabled={currentPage === 1}
      />
      <Pagination.Prev
        onClick={() => setCurrentPage(currentPage - 1)}
        disabled={currentPage === 1}
      />

      <Pagination.Item
        className={currentPage > 2 ? '' : 'd-none'}
        onClick={() => setCurrentPage(1)}
      >
        1
      </Pagination.Item>

      <Pagination.Ellipsis className={currentPage > 3 ? '' : 'd-none'} />

      <Pagination.Item
        className={currentPage !== 1 ? '' : 'd-none'}
        onClick={() => setCurrentPage(currentPage - 1)}
      >
        {currentPage - 1}
      </Pagination.Item>
      <Pagination.Item
        active
      >
        {currentPage}
      </Pagination.Item>
      <Pagination.Item
        onClick={() => setCurrentPage(currentPage + 1)}
        className={currentPage !== totalPage && totalPage > 1 ? '' : 'd-none'}
      >
        {currentPage + 1}
      </Pagination.Item>

      <Pagination.Ellipsis className={(totalPage) - currentPage > 2 ? '' : 'd-none'} />

      <Pagination.Item
        onClick={() => setCurrentPage(totalPage)}
        className={(totalPage) - currentPage > 1 ? '' : 'd-none'}
      >
        {totalPage}
      </Pagination.Item>

      <Pagination.Next
        onClick={() => setCurrentPage(currentPage + 1)}
        disabled={totalPage === currentPage || totalPage === 1 || totalPage === 0}
      />
      <Pagination.Last
        onClick={() => setCurrentPage(totalPage)}
        disabled={totalPage === currentPage || totalPage === 1 || totalPage === 0}
      />
    </Pagination>
  );
};

export default React.memo(RenderPagination);
